function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useEffect, useState } from 'react';
import { Button } from 'antd-mobile';
import { getPrefixCls } from "../../../utils/common";
import classNames from 'classnames';
import { isReceiveCoupon } from "../../../service/api";
var ContainerButton = function ContainerButton(props) {
  var _props$params, _props$schema, _props$schema$params, _classNames;
  var item = props.item,
    onBtnClick = props.onBtnClick;
  var prefixCls = getPrefixCls('SmContainer');
  var _ref = item || {},
    width = _ref.width,
    height = _ref.height,
    fontSize = _ref.fontSize,
    backgroundColor = _ref.backgroundColor,
    color = _ref.color,
    position = _ref.position,
    effect = _ref.effect;
  var source = ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.source) || ((_props$schema = props.schema) === null || _props$schema === void 0 ? void 0 : (_props$schema$params = _props$schema.params) === null || _props$schema$params === void 0 ? void 0 : _props$schema$params.source);
  var isDev = source === 'development';
  var isPreview = (props === null || props === void 0 ? void 0 : props.componentRenderStatus) === 'preview';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasReceived = _useState2[0],
    setHasReceived = _useState2[1];
  var queryIsReceiveCoupon = function queryIsReceiveCoupon(item) {
    var _item$couponIds;
    var couponIds = item === null || item === void 0 ? void 0 : (_item$couponIds = item.couponIds) === null || _item$couponIds === void 0 ? void 0 : _item$couponIds.map(function (item) {
      return item.value;
    });
    // 是否领取过优惠券
    isReceiveCoupon({
      discountIds: couponIds
    }).then(function (res) {
      if ((res === null || res === void 0 ? void 0 : res.status) === 0) {
        var _res$result;
        var hasReceivedTag = (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.every(function (item) {
          return !item.available;
        });
        setHasReceived(hasReceivedTag);
      }
    });
  };
  useEffect(function () {
    if (item.eventType === 'coupon') {
      queryIsReceiveCoupon(item);
    }
  }, []);
  var couponSuccessStyle = hasReceived ? {
    backgroundColor: item.receiveSuccessBtnColor,
    color: item.receiveSuccessBtnTextColor
  } : {};
  var couponTextStyle = hasReceived ? item.receiveSuccessBtnText : item === null || item === void 0 ? void 0 : item.text;
  return /*#__PURE__*/React.createElement(Button, {
    className: classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-button"), true), _defineProperty(_classNames, "".concat(prefixCls, "-heart"), effect === 'heart'), _classNames)),
    style: _objectSpread(_objectSpread({
      width: width ? "".concat(width, "%") : '100%',
      height: height ? "".concat(height, "px") : '40px',
      fontSize: "".concat(fontSize, "px"),
      backgroundColor: backgroundColor,
      color: color,
      paddingLeft: 0,
      paddingRight: 0
    }, couponSuccessStyle), position === null || position === void 0 ? void 0 : position.positionStyle),
    size: "small",
    onClick: function onClick() {
      var _onBtnClick;
      onBtnClick === null || onBtnClick === void 0 ? void 0 : (_onBtnClick = onBtnClick(item)) === null || _onBtnClick === void 0 ? void 0 : _onBtnClick.then(function () {
        if (hasReceived || item.eventType !== 'coupon') return;
        queryIsReceiveCoupon(item);
      });
    }
  }, couponTextStyle);
};
export default ContainerButton;